const departments = {
    leader: 'Responsable',
    leaders: 'Responsables del departamento',
    led_departments: 'Departamentos a cargo',
    edit_leaders: 'Gestionar responsables',
    add_leader: 'Añadir',
    remove_leader: 'Quitar',
    no_leaders: 'Sin responsables',
    local: 'Gestión local',
    managed_members: 'Miembros del ámbito gestionado',
    leader_scope_hint: 'Gestiona las asignaciones de tus departamentos y sus subdepartamentos.',
    leader_permission_hint: 'Los responsables gestionan las asignaciones de sus departamentos y subdepartamentos, sin cambiar roles ni jerarquías.',
    primary_synced: 'Feishu administra el departamento principal.',
    status_active: 'Activo',
    status_suspended: 'Suspendido',
    status_departed: 'Baja',
    status_pending: 'Pendiente de activación',
    search: 'Buscar',
    previous_page: 'Página anterior',
    next_page: 'Página siguiente',
    directory_title: 'Miembros de la organización',
    member_name: 'Miembro',
    search_members: 'Buscar por nombre o usuario',
    include_descendants: 'Incluir subdepartamentos',
    no_members: 'No hay miembros coincidentes.',
    all_members: 'Todos los miembros',
    all_departments: 'Todos los departamentos',
    edit_member: 'Editar departamentos',
    add_child: 'Añadir subdepartamento',
    expand_department: 'Expandir {{name}}',
    collapse_department: 'Contraer {{name}}',
    title: 'Departamentos',
    description: 'Gestiona los departamentos y las asignaciones de miembros de esta organización.',
    create: 'Crear departamento',
    edit: 'Editar departamento',
    name: 'Nombre del departamento',
    parent: 'Departamento superior',
    root: 'Sin departamento superior',
    id: 'ID del departamento',
    members: 'Departamentos de miembros',
    member_id: 'ID de usuario del miembro',
    primary: 'Departamento principal',
    none: 'Sin establecer',
    assignments: 'Asignaciones de departamentos',
    no_assignments: 'Aún no hay asignaciones de departamentos.',
    assignment_hint: 'Asigna departamentos locales y, opcionalmente, uno principal. Las asignaciones del directorio son de solo lectura.',
    empty: 'Aún no hay departamentos.',
    readonly: 'Puedes ver los departamentos y tus asignaciones. Contacta al administrador para realizar cambios.',
    load_error: 'No se pudieron cargar los datos. Inténtalo de nuevo.',
    mutation_error: 'No se pudo guardar. Revisa tus permisos, la membresía y la jerarquía de departamentos.',
    loading: 'Cargando…',
    synced: 'Gestionado por el directorio',
    choose: 'Buscar departamentos',
    organizations_title: 'Organizaciones y departamentos',
    organizations_description: 'Elige una organización para ver o gestionar sus departamentos.',
    no_organizations: 'No perteneces a ninguna organización. Contacta al administrador.',
    organization: 'Organización actual',
    choose_organization: 'Elige una organización',
    delete_title: 'Eliminar departamento',
    delete_description: '¿Eliminar «{{name}}»? Mueve primero sus miembros y subdepartamentos.',
};
export default Object.freeze(departments);
